import React from "react";

export default function Footer() {
    return (
        <div className="Footer">
            <p>© 2026 Grupo Tempestad</p>
        </div>
    );
}